(function () {
    'use strict';

    angular
        .module('app')
        .factory('NotesService', NotesService);

    NotesService.$inject = ['$http', 'DataService', 'UrlService', 'Upload', 'FileSelectorService', 'DialogService'];

    function NotesService($http, DataService, UrlService, Upload, FileSelectorService, DialogService) {
        var resourceUrl = 'note';
        var service = {};

        angular.extend(service, DataService(resourceUrl));

        angular.extend(service, {
            save: save,
            exportNotes: exportNotes,
            importNotes: importNotes
        });

        return service;


        /**
         * Save a new note, or update an existing one.
         *
         * @param {object} note - The note to save
         * @returns {promise} A promise that resolves when the note is successfully saved, or an error occurred.
         */
        function save(note) {
            var method;
            var url;

            if (_.isNil(note.Id)) {
                // Nil ID means new note
                method = 'POST';
                url = UrlService.getWebAPIUrl() + '/note/';
            } else {
                method = 'PUT';
                url = UrlService.getWebAPIUrl() + '/note/' + note.Id;
            }

            var req = {
                method: method,
                url: url,
                data: note
            };

            return $http(req)
                .then(function (response) {
                    return response.data;
                });
        }

        /**
         * Export notes to a spreadsheet.
         * This function shows the dialog to select export options, as well as displays an error dialog
         * if something goes wrong.
         *
         * @param {number} parentItemId - The ID of the parent to export notes for.
         * @param {array} selectedNoteIds - Array of {number} for selected note ids.
         * @return {promise} Resolves once notes are successfully imported, or rejects with an error response.
         */
        function exportNotes(parentItemId, selectedNoteIds) {
            return DialogService.show({
                locals: { parentItemId: parentItemId, selectedNoteIds: selectedNoteIds },
                controller: 'ExportItemsDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/Item/export-items-dialog.tmpl.html'
            }).then(dialogOk);

            function dialogOk(exportOptions) {
                return $http.post(UrlService.getWebAPIUrl() + '/note/export', exportOptions, { responseType: 'arraybuffer' })
                    .then(exportOk, exportError);
            }

            function exportOk(response) {
                var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                var fileName = response.headers('Content-Disposition').match(/filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/)[1];
                fileName = fileName.replace(/^"/, '');
                fileName = fileName.replace(/"$/, '');
                saveAs(blob, fileName);
            }

            function exportError(response) {
                DialogService.error('Error exporting Notes', response);
            }
        }

        /**
         * Import notes from a spreadsheet.
         * This function shows the file selector dialog, and an error dialog if something goes wrong.
         *
         * @param {number} parentItemId - The ID of the parent to import notes for.
         * @return {promise} Resolves once notes are successfully imported, or rejects with an error response.
         */
        function importNotes(parentItemId) {
            return FileSelectorService.selectLocalFileDialog(false, ['xlsx', 'xlsm'])
                .then(fileSelectorOk);

            function fileSelectorOk(files) {
                return Upload.upload({
                    url: UrlService.getWebAPIUrl() + '/note/import',
                    data: {
                        files: [files[0].File],
                        'jsonData': angular.toJson({ NotesParentId: parentItemId })
                    },
                    method: 'POST'
                }).then(uploadOk, uploadError);
            }

            function uploadOk(response) {
                DialogService.show({
                    locals: { importReportData: response.data },
                    controller: 'ItemImportReportDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/Item/item-import-report-dialog.tmpl.html'
                });
            }

            function uploadError(response) {
                DialogService.error('Error importing Notes', response);
            }
        }
    }
})();